<ng-template #pointsExplainer>
  <div class="p-4">
    <app-my-tabs [tabs]="rewardExplanationTabs">
      <div tab0>
        <p>Total Points Now: {{ points }}</p>
        <p>Total Earned: {{ totalEarned }}</p>
      </div>

      <div class="table-responsive" tab1>
        <table class="table table-bordered">
          <thead>
            <th>Date</th>
            <th>Claimed Reward</th>
            <th>description</th>
          </thead>
          <tbody>
            <tr *ngFor="let claim of claims">
              <td>{{ claim.createdAt }}</td>
              <td>{{ claim.rewardTitle }}</td>
              <td>{{ claim.rewardDescription }}</td>
            </tr>
            <tr *ngIf="claims.length === 0">
              <td colspan="4" class="text-center">No Rewards Claimed.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-responsive" tab2>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Date</th>
              <th>Points Received</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let reward of rewardsRecieved">
              <td>{{ reward.updatedAt | date : "short" }}</td>
              <td>
                @if(reward.points){
                {{ reward.points }}
                } @else{
                <button class="btn" style="color: var(--secondary)">Limit Exceeded</button>
                }
              </td>
              <td>
                <button class="t-btn">
                  {{ changeRewardKeyName(reward.actionType) }}
                </button>
              </td>
            </tr>
            <tr *ngIf="rewardsRecieved.length === 0">
              <td colspan="4" class="text-center">No Rewards Received.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-responsive" tab3>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Date</th>
              <th>Points Used</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let usage of pointsUsed">
              <td>{{ usage.updatedAt | date : "short" }}</td>
              <td>
                @if(usage.points){
                {{ usage.points }}
                } @else{
                <button class="btn" style="color: var(--secondary)">Limit Exceeded</button>
                }
              </td>
              <td>
                <button class="t-btn">
                  {{ usage.actionType }}
                </button>
              </td>
            </tr>
            <tr *ngIf="pointsUsed.length === 0">
              <td colspan="4" class="text-center">No Points Used.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </app-my-tabs>
  </div>
</ng-template>
<div class="my-profile" [ngClass]="bgBody || ''">
  <div class="container" style="position: relative">
    <!-----------------------ADS----------------------------------------->
    <div #rightAd class="ad ad-right" *ngIf="showAdRight && currentRightAd">
      <div class="image-container">
        <button class="my-button-3 close-btn"><i class="fa fa-x" (click)="tempCloseAdRight()"></i></button>
        <img (click)="openCorrectedLink(currentRightAd.adLink)" [src]="imgUrl + currentRightAd.imageLocation" />
      </div>
    </div>

    <div #leftAd class="ad ad-left" *ngIf="showAdLeft && currentLeftAd">
      <div class="image-container">
        <button class="my-button-3 close-btn" (click)="tempCloseAdLeft()"><i class="fa fa-x"></i></button>
        <img (click)="openCorrectedLink(currentLeftAd.adLink)" [src]="imgUrl + currentLeftAd.imageLocation" />
      </div>
    </div>

    <!------------------------------------------------------------------->

    <div class="header">
      <div class="my-profile__nav">
        <div class="my-profile__nav--bar">
          <div class="my-profile__nav--bar__name">
            <div *ngIf="url != '/me'" class="back" (click)="goBack()">
              <i class="fa-solid fa-chevron-left"></i>
            </div>
            <div>
              Welcome, <span>{{ userName }}</span>
            </div>
          </div>
          <!-- <a (click)="openPointsExplainer()" style="display: flex; align-items: center; color: #f0c144; font-size: 1.5rem; gap: 0.25rem; font-weight: 500; line-height: 1; border-radius: 0.25rem; border: 1px solid #f0c144; padding: 0.4rem 0.5rem"><img src="../../../../../assets/images/gold-coin.png" class="gold-coin" /> {{ points }}</a> -->
          <div class="button-coin" (click)="openPointsExplainer()">
            <div class="button-coin__icon">
              <img src="/assets/images/star-coin.png" />
              <img class="shine" src="/assets/images/shine.webp" />
            </div>
            <div class="button-coin__text">{{ points }}</div>
          </div>
        </div>
        <ul>
          <li>
            <a routerLinkActive="active" (click)="onNavigate('profile')" routerLink="profile">
              <div class="circle">
                <i class="fa-solid fa-user"></i>
              </div>
              <div class="name">Profile</div>
            </a>
          </li>
          <li>
            <a routerLinkActive="active" (click)="onNavigate('nearby')" routerLink="nearby">
              <div class="circle">
                <i class="fa-solid fa-map-location-dot"></i>
              </div>
              <div class="name">Nearby</div>
            </a>
          </li>

          <li>
            <a routerLinkActive="active" (click)="onNavigate('list')" routerLink="list">
              <div class="circle">
                <i class="fa-sharp fa-solid fa-plus"></i>
              </div>
              <div class="name">List</div>
            </a>
          </li>
          <li>
            <a routerLinkActive="active" (click)="onNavigate('around')" routerLink="around">
              <div class="circle">
                <i class="fa-solid fa-users"></i>
              </div>
              <div class="name">People</div>
            </a>
          </li>
          <li>
            <a routerLinkActive="active" (click)="onNavigate('shout-out')" routerLink="shout-out">
              <div class="circle">
                <svg viewBox="0 0 668 434" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M134 86.6656L167.333 83.3333L500.667 0C522.889 66.6667 534 133.333 534 200C534 266.667 522.889 333.333 500.667 400L316.516 353.963C310.508 398.774 272.123 433.333 225.667 433.333C176.916 433.333 137.053 395.277 134.167 347.251L134 341.667L134 86.6656ZM562.017 279.997L659.454 302.492L644.457 367.45L547.02 344.955L562.017 279.997ZM200.667 325V341.667C200.667 355.474 211.86 366.667 225.667 366.667C238.323 366.667 248.783 357.262 250.439 345.059L250.667 341.667V337.5L200.667 325ZM100.667 90V310L0.666748 300V100L100.667 90ZM667.333 166.667V233.333H567.333V166.667H667.333ZM644.457 32.5504L659.454 97.5084L562.017 120.003L547.02 55.0455L644.457 32.5504Z" fill="var(--primary)" />
                </svg>
              </div>
              <div class="name">Shout</div>
            </a>
          </li>
        </ul>
        <div class="my-profile__nav--bottom">
          @if(roleService?.roles?.userType.includes('ADMIN') && isLocationNeaby){
          <select (change)="servicesSubRegionChange($event)">
            <option selected>Select to change</option>
            <option [value]="subRegion.subRegionId" *ngFor="let subRegion of subRegions">{{ subRegion.name }}</option>
          </select>
          }
          <div class="my-profile__nav--bottom__region">
            <div class="text">{{ selectedMemberRegion ? selectedMemberRegion.split("|")[0] : "" }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="header-image">
      <div class="overlay">
        <div class="d-flex w-100 justify-content-between p-2">
          <div class="name">
            <div *ngIf="url != '/me'" class="back" (click)="goBack()">
              <i class="fa-solid fa-chevron-left"></i>
            </div>
            <div>
              Welcome, <span>{{ userName }}</span>
            </div>
          </div>
          <!-- <a (click)="openPointsExplainer()" style="display: flex; align-items: center; color: #f0c144; font-size: 1.15rem; gap: 0.25rem; font-weight: 500; line-height: 1; border-radius: 0.25rem; border: 1px solid #f0c144; padding: 0.4rem 0.5rem; transform: translateX(8px)"> <img src="../../../../../assets/images/gold-coin.png" class="gold-coin" /> {{ points }}</a> -->

          <div class="button-coin" (click)="openPointsExplainer()">
            <div class="button-coin__icon">
              <img src="/assets/images/star-coin.png" />
              <img class="shine" src="/assets/images/shine.webp" />
            </div>
            <div class="button-coin__text">{{ points }}</div>
          </div>
        </div>

        <div class="region">
          {{ selectedMemberRegion ? selectedMemberRegion.split("|")[0] : "" }}
        </div>
      </div>
    </div>
  </div>

  <router-outlet></router-outlet>
</div>
<div class="carousel-pages" id="carousel-pages">
  <div class="container">
    <!-- <app-my-tabs [defaultTabIndex]="indexTab" [tabs]="tabs" (tabChange)="getTabData($event)">
      <div tab1>
        <app-my-carousel-swiper [config]="carouselOptions">
          @for(item of supportOwnerList; track item){
          <div class="swiper-slide">
            <ng-container *ngIf="item.type ==  'community' else biz">

              <a (click)="navigateToShop(item)" class="card-page-supported">
                <div class="image">
                  @if(item?.businessDetails?.profileCharacterImageFile){
                  <img loading="lazy" [src]="imgUrl + item?.businessDetails?.profileCharacterImageFile"
                    [alt]="item?.businessDetails?.profileCharacterName" />
                  }@else {
                  <img loading="lazy" src="../../../../assets/images/shop/default.png" alt="" />
                  }
                </div>
                <div class="card-page-supported__body">
                  <div class="card-page-supported__body--name">{{ item?.businessDetails?.profileCharacterName |
                    titlecase }}</div>
                  <div class="card-page-supported__body--cate">{{ item.type | uppercase }}</div>
                </div>
              </a>
            </ng-container>
            <ng-template #biz>
              <a (click)="navigateToShop(item)" class="card-page-supported">
                <div class="image">
                  @if(item?.userDetails?.shop_logo){
                  <img loading="lazy" [src]="imgUrl + item?.userDetails?.shop_logo"
                    [alt]="(item?.userDetails?.first_name + i?.userDetails?.last_name)" />
                  }@else {
                  <img loading="lazy" src="../../../../assets/images/shop/default.png" alt="" />
                  }
                </div>
                <div class="card-page-supported__body">
                  <div class="card-page-supported__body--name">{{ (item?.userDetails?.first_name +
                    i?.userDetails?.last_name) |
                    titlecase }}</div>
                  <div class="card-page-supported__body--cate">{{ item.type | uppercase }}</div>
                </div>
              </a>
            </ng-template>
          </div>
          }@empty {
          <div class="no-product">
            <div class="no-product__title">You Have Not Supported Anyone</div>
          </div>
          }
        </app-my-carousel-swiper>
      </div>
      <div tab2>
        <app-my-carousel-swiper *ngIf="allBizProductByRegion && allBizProductByRegion.length > 0"
          class="my-carousel-width-auto" [slide]="allBizProductByRegion" [config]="carouselOptions">
          @for(list of allBizProductByRegion;track list){
          <div class="swiper-slide">
            <common-product-card-view (view)="viewProductDetails($event)" [list]="list" [isCommunityProduct]="true">
            </common-product-card-view>
          </div>
          }
        </app-my-carousel-swiper>

        @if(allBizProductByRegion.length == 0) {
        <div class="no-product">
          <div class="no-product__title">No Businesses Found</div>
        </div>
        }
      </div>
      <div tab3>
        <app-my-carousel-swiper *ngIf="jobList && jobList.length > 0" class="my-carousel-width-auto" [slide]="jobList"
          [config]="carouselOptions">
          @for(item of jobList; track item){
          <div class="swiper-slide">
            <a class="card-job" (click)="openJobPopup(item, JobPopup)">
              <div class="card-job__header">
                <div class="card-job__header--img">
                  {{ item.title.charAt(0) }}
                </div>
                <div>
                  <div class="card-job__header--title">{{ item.title | uppercase }}</div>
                  <div class="card-job__header--desc">{{ item.description }}</div>
                </div>
              </div>
              <div class="card-job__meta">
                <div><small>Posted At</small> {{ item.createdAt | date : "dd/MM/yyyy" }}</div>
                <div class="card-job__meta--view"><i class="fa fa-eye" aria-hidden="true"></i> {{ item.viewsCount }}
                </div>
              </div>
            </a>
          </div>

          }@empty {
          <div class="no-product">
            <div class="no-product__title">No Jobs</div>
          </div>
          }
        </app-my-carousel-swiper>

        <div *ngIf="jobList.length < 1" class="no-product">
          <div class="no-product__title">No Jobs</div>
        </div>
      </div>
      @if(roleService.roles?.level?.includes('MEMBER_COMMUNITY_VOUCHERS_TAB')) {
      <div tab4>
        <div class="gallery">
          @if(userReferralUploadedFile.length > 0) {
          <div class="gallery__body-2">
            <div style="position: relative;" *ngFor="let file of userReferralUploadedFile; let i = index">
              <img loading="lazy" class="rounded" (click)="openShowImageModal(ShowImageModal, file)"
                [src]="imgUrl + file.file" alt="" />
              <div class="btn-group" style="position: absolute; top: 0; right: 0; cursor: pointer;">
                <button *ngIf="file.category != 'gallery'" class="btn btn-sm btn-danger" [disabled]="file.claimed"
                  (click)="handleClaim(file.id, file.category)">
                  <i class="fa-solid fa-hand-holding-usd"></i> {{ file.claimed ? "Claimed" : "Claim" }}
                </button>
              </div>
            </div>
          </div>
          }@else {
          <div class="no-product">
            <div class="no-product__title">No Vouchers Found</div>
          </div>
          }
        </div>
      </div>
      }
    </app-my-tabs> -->
  </div>
  <div class="container">
    @if(bannerImagesList.length) {
    <app-add-product-crousel-cust design="2" [local]="false" [images]="bannerImagesList"></app-add-product-crousel-cust>
    }
  </div>
</div>

<app-marketplace #marketplace [share]="true"></app-marketplace>

<ng-template #JobPopup let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body p-4 pb-2">
    <div class="form-group">
      <div class="logos__card">
        <div class="title">{{ selectedJob?.title | titlecase }}</div>
        <div class="">{{ selectedJob?.description }}</div>
        <div class="">Posted At - {{ selectedJob.createdAt | date : "dd/MM/yyyy" }}</div>
        <section class="d-flex justify-content-lg-between mt-5">
          <div><i class="fa fa-clock-o" aria-hidden="true"></i> {{ selectedJob?.daysLeft }} day left</div>
          <div><i class="fa fa-eye" aria-hidden="true"></i> {{ selectedJob.viewsCount }}</div>
        </section>
      </div>
    </div>
  </div>
</ng-template>
